<template>
  <div class="AccessibilityMenu">
    <ul
      v-if="menuOpen || type === 'list'"
      :class="['menu', { 'menu--list': type === 'list', 'menu--default': type !== 'list' }]"
    >
      <li
        v-for="option in options"
        :key="option"
      >
        <button
          class="menu-item"
          :class="{ active: isActive(option) }"
          @click="handleAccessibilityUpdate(option)"
        >
          <UIIconComponent :icon="'accessibility'" />
          {{ getOptionLabel(option) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import type { AccessibilityOptions } from '@tc8l/nuxt-base'

  defineProps<{
    type?: string | null
    options: AccessibilityOptions[]
  }>()

  const {
    lowStimulusActive,
    highContrastActive,
    largeTextActive,
    handleAccessibilityUpdate,
    isActive,
    getOptionLabel,
  } = useBaseAccessibility()

  const { translate } = useTranslations()
  const menuOpen = ref(false)

  const toggleMenu = () => {
    menuOpen.value = !menuOpen.value
  }

  let stopLowStimulusWatch = null

  // Pause or play videos based on lowStimulusActive
  onMounted(() => {
    stopLowStimulusWatch = watch(lowStimulusActive, PauseOrPlayVideos)
  })

  onUnmounted(() => {
    stopLowStimulusWatch()
  })

  function PauseOrPlayVideos(value: boolean) {
    const videos = document.querySelectorAll('video')

    if (value) {
      videos.forEach((video) => {
        video.pause()
      })
    } else {
      videos.forEach((video) => {
        video.play()
      })
    }
  }
</script>

<style lang="scss" scoped>
  .AccessibilityMenu {
    position: relative;

    .menu {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2.4rem;

      li {
        display: flex;
        flex-direction: column;
        width: 100%;
        font-size: inherit;
        border: 2px solid $black;
        border-radius: 0.8rem;
        font-size: 1.6rem;
        color: $black;
        transition: 0.4s all var(--ease-fast-in-slow-out);

        &:hover {
          background-color: $black;
          color: $white;
        }

        .icon {
          font-size: 2.2rem;
          margin-bottom: 0.8rem;
        }
      }

      .menu-item {
        padding: 10px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;

        &.active {
          font-weight: bold;
        }
      }
    }
  }
</style>
